import routeDescriptions from 'root/src/shared/descriptions/routes'
import pathOr from 'ramda/src/pathOr'
import currentRouteId from 'root/src/client/logic/route/selectors/currentRouteId'

export default state => pathOr(undefined, [currentRouteId(state), 'restriction'], routeDescriptions)
